import React from 'react';
import { Drawer as ChakraDrawer, DrawerProps as ChakraDrawerProps } from '@chakra-ui/react';

export function Drawer(props: ChakraDrawerProps) {
  return <ChakraDrawer {...props} />;
}
